import { useTranslation } from "react-i18next";
import { Outlet } from "react-router-dom";

import { Card } from "@/components/ui/card";
import { useEffectivePermissions, useHasPermission } from "@/lib/auth/permissions";

export function ReportsGuard() {
  const { t } = useTranslation();
  const { isLoading: permsLoading } = useEffectivePermissions();

  const hasFinancial = useHasPermission("reports.financial");
  const hasMembers = useHasPermission("reports.members");
  const hasOperations = useHasPermission("reports.operations");
  const hasTools = useHasPermission("reports.tools");
  const hasCheckinLog = useHasPermission("reports.checkin_log.view");
  const hasLeaveReport = useHasPermission("reports.leave_report.view");
  const hasDailySales = useHasPermission("pos.sale.read");
  const canView = hasFinancial || hasMembers || hasOperations || hasTools || hasCheckinLog || hasLeaveReport || hasDailySales;

  if (permsLoading) {
    return null;
  }

  if (!canView) {
    return (
      <div className="p-6 max-w-6xl mx-auto">
        <Card className="text-sm text-ink-500 p-6">
          {t("rbac.noAccess")}
        </Card>
      </div>
    );
  }

  return <Outlet />;
}